import React from 'react';
import styled from 'styled-components';

import { PublicPage } from 'api/website';
import { getIsContentFullWidthLayout } from 'cms/helpers';
import { FilestackImage } from 'components/Image';
import { BodySmall } from 'components/Text';
import { colors } from 'theme';

const HeaderImage = styled.div`
  img {
    height: 100%;
    width: 100%;
  }
`;

type Props = {
  content: PublicPage;
};

export function ContentPageHeaderImage({ content }: Props) {
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    <HeaderImage>
      <FilestackImage
        data-qa-id="cms-page-header-image"
        data={content.headerImage}
        width={fullWidthLayout ? 1152 : 952}
        alt={
          content.headerImage.altText
            ? content.headerImage.altText
            : content.title
        }
      />
      {content.headerImage.caption && (
        <BodySmall color={colors.battleshipGrey} mt="8px">
          {content.headerImage.caption}
        </BodySmall>
      )}
    </HeaderImage>
  );
}
